module.exports = __webpack_public_path__ + "img/arctic-circle-logo.dc2036dd.svg";